import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "../hooks/useTranslation";
import LanguageSelector from "./LanguageSelector";

function Header() {
  const location = useLocation();
  const currentPath = location.pathname;
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const { t } = useTranslation();

  // Determine if we should use white theme (for About, Products, Work pages)
  const useWhiteTheme = !["/", "/contact", "/calculator"].includes(currentPath);

  // Check if mobile on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 992);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Determine logo to use - always use black logo on mobile
  const logoSrc = isMobile
    ? "/logoBlackLong.svg"
    : useWhiteTheme
    ? "/logoWhiteLong.svg"
    : "/logoBlackLong.svg";

  useEffect(() => {
    setMenuOpen(false);
  }, [currentPath]);

  return (
    <div className="header-container">
      <div className={`header-wrapper ${useWhiteTheme ? "white-theme" : ""}`}>
        <div className="header container flex">
          <div className="header-left flex">
            <Link to="/">
              <img className="header-img" src={logoSrc} alt="MTA Logo" />
            </Link>
            <button
              className={`header-menu-toggle ${menuOpen ? "open" : ""}`}
              onClick={() => setMenuOpen((prev) => !prev)}
              aria-label="Toggle navigation"
              aria-expanded={menuOpen}
            >
              <span />
              <span />
              <span />
            </button>
          </div>
          <div className={`header-content flex ${menuOpen ? "open" : ""}`}>
            <div className="header-links flex">
              <Link
                className={`fs-500 transition pointer ${
                  currentPath === "/" ? "active" : ""
                }`}
                to="/"
              >
                {t("header.home")}
              </Link>
              <Link
                className={`fs-500 transition pointer ${
                  currentPath === "/products" ? "active" : ""
                }`}
                to="/products"
              >
                {t("header.products")}
              </Link>
              <Link
                className={`fs-500 transition pointer ${
                  currentPath === "/about" ? "active" : ""
                }`}
                to="/about"
              >
                {t("header.about")}
              </Link>
              <Link
                className={`fs-500 transition pointer ${
                  currentPath === "/work" ? "active" : ""
                }`}
                to="/work"
              >
                {t("header.ourWorks")}
              </Link>
              <Link
                className={`fs-500 transition pointer ${
                  currentPath === "/contact" ? "active" : ""
                }`}
                to="/contact"
              >
                {t("header.contact")}
              </Link>
              {isMobile && (
                <>
                  <Link
                    className={`fs-500 transition pointer ${
                      currentPath === "/calculator" ? "active" : ""
                    }`}
                    to="/calculator"
                  >
                    {t("header.calculator")}
                  </Link>
                  <a
                    href="/catalog.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="fs-500 transition pointer"
                  >
                    {t("header.catalog")}
                  </a>
                </>
              )}
            </div>
            <div className="header-mobile-right flex">
              <a
                href="https://wa.me/+38344175555"
                target="_blank"
                rel="noopener noreferrer"
                className="header-contact flex"
              >
                <img src="/assets/icons/phone.svg" alt="Phone Icon" />
                <p className="fs-400">+383 44 175 555</p>
              </a>
              <LanguageSelector />
            </div>
          </div>
          <div className="header-right flex">
            <a
              href="https://wa.me/+38344175555"
              target="_blank"
              rel="noopener noreferrer"
              className="header-contact flex"
            >
              <img src="/assets/icons/phone.svg" alt="Phone Icon" />
              <p className="fs-400">+383 44 175 555</p>
            </a>
            <LanguageSelector />
            <div
              className={`calculator-wrapper ${
                currentPath !== "/" ? "no-bg" : ""
              }`}
            >
              <div className="calculator flex">
                <Link to="/calculator" className="flex">
                  <img
                    src="/assets/icons/calculator.svg"
                    alt="Calculator Icon"
                  />
                  <p className="fs-400 clr-white">{t("header.calculator")}</p>
                </Link>
                <a
                  href="/catalog.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex"
                >
                  <img src="/assets/icons/catalog.svg" alt="Catalog Icon" />
                  <p className="fs-400 clr-white">{t("header.catalog")}</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
